/** ADR 0010 status-location protocol; omitted fields preserve legacy Agent calls. */
export const LOCATION_OVERRIDE_REASONS = [
  'GPS_INACCURATE',
  'MEETING_POINT_INCORRECT',
  'PASSENGER_REQUESTED_DIFFERENT_POINT',
  'EMERGENCY',
  'OTHER',
] as const;
export type LocationOverrideReason = (typeof LOCATION_OVERRIDE_REASONS)[number];
export const STATUS_LOCATION_EVENTS = [
  'GPS_ARRIVED_PICKUP',
  'GPS_ARRIVED_DROPOFF',
  'STARTED',
  'ARRIVED_PICKUP',
  'PICKED_UP',
  'ARRIVED_DROPOFF',
  'CARE_STARTED',
  'CARE_FINISHED',
  'RETURN_STARTED',
  'RETURN_PICKED_UP',
  'RETURN_ARRIVED_DROPOFF',
  'COMPLETED',
  'CANCELLED',
  'MISSED',
] as const;
export interface AgentAdvanceLocation {
  locationEvidence?: {
    clientPointId: string;
    lat: number;
    lng: number;
    capturedAt: string;
    accuracyM: number;
  };
  locationOverride?: { reason: LocationOverrideReason; note?: string };
  locationPolicyVersion?: 1;
  /** Required with protocol version 1; identifies the intended lifecycle transition. */
  expectedTripVersion?: number;
}
export interface StatusLocationEvidence {
  source: 'DIRECT' | 'TRACE_FALLBACK' | null;
  tracePointId: string | null;
  capturedAt: string | null;
  accuracyM: number | null;
  target: 'ORIGIN' | 'DESTINATION' | null;
  distanceToTargetM: number | null;
  warningRadiusM: number | null;
  warningConfigScope: 'SERVICE_GROUP' | 'PROVIDER' | 'GLOBAL' | null;
  warning: 'NONE' | 'OUTSIDE_RADIUS' | 'LOCATION_UNAVAILABLE' | 'LOW_ACCURACY';
  overrideReason: LocationOverrideReason | null;
  overrideNote: string | null;
  confirmation: 'NOT_REQUIRED' | 'OVERRIDE' | 'LEGACY_NO_CONFIRMATION';
}
